import { useState } from 'react';

export const NahrainDescription = ({
                                       className,
                                       placeholder,
                                       onChange,
                                       icon,
                                       maxLength = 500,
                                       initialValue = ""
                                   }) => {
    const [value, setValue] = useState(initialValue);

    const handleChange = (e) => {
        const newValue = e.target.value;
        if (newValue.length <= maxLength) {
            setValue(newValue);
            onChange(newValue);
        }
    };
    return (
        <div className={`${className} relative`}>
            {icon && (
                <div className={`absolute top-4 start-4 text-onBackgroundCaption`}>
                    {icon}
                </div>
            )}

            <textarea
                className={`
          ${icon ? "ps-12" : "ps-4"}
          text-onBackground max-w-full w-full py-4 pe-4 rounded-lg
          bg-transparent border border-strokeGray transition-colors
          focus:outline-none focus:border-secondary
          placeholder-onBackgroundCaption resize-none
          min-h-[120px]
        `}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                maxLength={maxLength}
            />

            <div className={`flex justify-between items-center mt-1 px-1`}>

                <span className={`text-xs text-onBackgroundCaption ml-auto`}>
          {value.length}/{maxLength}
        </span>
            </div>
        </div>
    );
};